var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#2B87AE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.217 111H79.5582V41.1818H103.695C110.626 41.1818 116.581 42.5795 121.558 45.375C126.558 48.1477 130.399 52.1364 133.081 57.3409C135.763 62.5455 137.104 68.7727 137.104 76.0227C137.104 83.2955 135.751 89.5455 133.047 94.7727C130.365 100 126.49 104.011 121.422 106.807C116.376 109.602 110.308 111 103.217 111ZM92.206 100.057H102.604C107.467 100.057 111.524 99.1705 114.774 97.3977C118.024 95.6023 120.467 92.9318 122.104 89.3864C123.74 85.8182 124.558 81.3636 124.558 76.0227C124.558 70.6818 123.74 66.25 122.104 62.7273C120.467 59.1818 118.047 56.5341 114.842 54.7841C111.661 53.0114 107.706 52.125 102.979 52.125H92.206V100.057ZM149.121 111V41.1818H175.848C180.893 41.1818 185.087 41.9773 188.428 43.5682C191.791 45.1364 194.303 47.2841 195.962 50.0114C197.643 52.7386 198.484 55.8295 198.484 59.2841C198.484 62.125 197.939 64.5568 196.848 66.5795C195.757 68.5795 194.291 70.2045 192.45 71.4545C190.609 72.7045 188.553 73.6023 186.28 74.1477V74.8295C188.757 74.9659 191.132 75.7273 193.405 77.1136C195.7 78.4773 197.575 80.4091 199.03 82.9091C200.484 85.4091 201.212 88.4318 201.212 91.9773C201.212 95.5909 200.337 98.8409 198.587 101.727C196.837 104.591 194.2 106.852 190.678 108.511C187.155 110.17 182.723 111 177.382 111H149.121ZM161.768 100.432H175.371C179.962 100.432 183.268 99.5568 185.291 97.8068C187.337 96.0341 188.359 93.7614 188.359 90.9886C188.359 88.9205 187.848 87.0568 186.825 85.3977C185.803 83.7159 184.348 82.3977 182.462 81.4432C180.575 80.4659 178.325 79.9773 175.712 79.9773H161.768V100.432ZM161.768 70.875H174.28C176.462 70.875 178.428 70.4773 180.178 69.6818C181.928 68.8636 183.303 67.7159 184.303 66.2386C185.325 64.7386 185.837 62.9659 185.837 60.9205C185.837 58.2159 184.882 55.9886 182.973 54.2386C181.087 52.4886 178.28 51.6136 174.553 51.6136H161.768V70.875Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.998 301.143C259.041 301.143 279.642 299.143 298.801 295.144C317.96 291.145 333.073 285.239 344.141 277.426V301.143C344.141 307.56 339.351 313.513 329.772 319C320.192 324.487 307.171 328.835 290.709 332.044C274.247 335.253 256.344 336.857 236.998 336.857C217.653 336.857 199.749 335.253 183.287 332.044C166.825 328.835 153.805 324.487 144.225 319C134.645 313.513 129.855 307.56 129.855 301.143V277.426C140.923 285.239 156.037 291.145 175.196 295.144C194.355 299.143 214.956 301.143 236.998 301.143ZM236.998 408.286C259.041 408.286 279.642 406.286 298.801 402.287C317.96 398.288 333.073 392.382 344.141 384.569V408.286C344.141 414.703 339.351 420.656 329.772 426.143C320.192 431.63 307.171 435.978 290.709 439.187C274.247 442.396 256.344 444 236.998 444C217.653 444 199.749 442.396 183.287 439.187C166.825 435.978 153.805 431.63 144.225 426.143C134.645 420.656 129.855 414.703 129.855 408.286V384.569C140.923 392.382 156.037 398.288 175.196 402.287C194.355 406.286 214.956 408.286 236.998 408.286ZM236.998 354.714C259.041 354.714 279.642 352.715 298.801 348.715C317.96 344.716 333.073 338.81 344.141 330.998V354.714C344.141 361.132 339.351 367.084 329.772 372.571C320.192 378.059 307.171 382.407 290.709 385.616C274.247 388.824 256.344 390.429 236.998 390.429C217.653 390.429 199.749 388.824 183.287 385.616C166.825 382.407 153.805 378.059 144.225 372.571C134.645 367.084 129.855 361.132 129.855 354.714V330.998C140.923 338.81 156.037 344.716 175.196 348.715C194.355 352.715 214.956 354.714 236.998 354.714ZM236.998 194C256.344 194 274.247 195.604 290.709 198.813C307.171 202.022 320.192 206.37 329.772 211.857C339.351 217.344 344.141 223.297 344.141 229.714V247.571C344.141 253.989 339.351 259.941 329.772 265.429C320.192 270.916 307.171 275.264 290.709 278.473C274.247 281.681 256.344 283.286 236.998 283.286C217.653 283.286 199.749 281.681 183.287 278.473C166.825 275.264 153.805 270.916 144.225 265.429C134.645 259.941 129.855 253.989 129.855 247.571V229.714C129.855 223.297 134.645 217.344 144.225 211.857C153.805 206.37 166.825 202.022 183.287 198.813C199.749 195.604 217.653 194 236.998 194Z",
    fill: "url(#paint0_linear_106_908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_908",
    x: 67.5586,
    y: 41.1836,
    width: 137.652,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_908",
    x1: 236.998,
    y1: 194,
    x2: 236.998,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CCEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00618A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/db.4ddfd10b9973fde0a736496e7c13df98.svg";
export { ForwardRef as ReactComponent };